export const spacing = {
  0: 0,
  1: 4,
  2: 8,
  3: 12,
  4: 16,
  5: 20,
  6: 24,
  8: 32,
  10: 40,
  12: 48,
  16: 64,
};

// OpenAI-inspired border radius scale
export const borderRadius = {
  none: 0,
  '2xs': 2,
  xs: 4,
  sm: 6,
  md: 8,
  lg: 10,
  xl: 12,
  '2xl': 16,
  '3xl': 20,
  '4xl': 24,
  full: 9999,
};

export const chatLayout = {
  maxContentWidth: 768,
  sidebarWidth: 260,
  messageSpacing: 24,
  messageBubbleRadius: 12,
  inputMaxLines: 4,
  streamingThrottleMs: 50,
};

// React Native shadow presets (inspired by OpenAI shadow scale)
export const shadows = {
  hairline: {
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.04,
    shadowRadius: 1,
    elevation: 1,
  },
  sm: {
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.04,
    shadowRadius: 4,
    elevation: 2,
  },
  md: {
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.08,
    shadowRadius: 8,
    elevation: 4,
  },
  lg: {
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 8 },
    shadowOpacity: 0.10,
    shadowRadius: 16,
    elevation: 8,
  },
  xl: {
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 16 },
    shadowOpacity: 0.12,
    shadowRadius: 32,
    elevation: 16,
  },
};

// Standardized control sizes for buttons/inputs
export const controlSize = {
  xs: { height: 28, paddingHorizontal: 8, fontSize: 11, iconSize: 14, radius: 6 },
  sm: { height: 32, paddingHorizontal: 12, fontSize: 12, iconSize: 16, radius: 6 },
  md: { height: 40, paddingHorizontal: 16, fontSize: 13, iconSize: 18, radius: 8 },
  lg: { height: 48, paddingHorizontal: 20, fontSize: 14, iconSize: 20, radius: 10 },
  xl: { height: 56, paddingHorizontal: 24, fontSize: 16, iconSize: 22, radius: 12 },
};
